var map = {
	"./pageConfig_admission_referral_form.json": [
		2400,
		400
	],
	"./pageConfig_alumni_occupation.json": [
		5304,
		304
	],
	"./pageConfig_appeal_video.json": [
		6760,
		760
	],
	"./pageConfig_cover_banner.json": [
		3392,
		392
	],
	"./pageConfig_current_location_country.json": [
		3576,
		576
	],
	"./pageConfig_directory_stats.json": [
		896,
		896
	],
	"./pageConfig_enquiry_form.json": [
		3916,
		916
	],
	"./pageConfig_top_careers.json": [
		6688,
		688
	],
	"./pageConfig_top_colleges.json": [
		3344,
		344
	],
	"./pageConfig_top_companies.json": [
		4760,
		140
	],
	"./pageConfig_top_industries.json": [
		8412,
		412
	],
	"./pageConfig_top_study_country.json": [
		5984,
		984
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8508;
module.exports = webpackAsyncContext;